import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="m34 38 6 6 20-20m-12-2H31.6c-3.36 0-5.04 0-6.324.654a6 6 0 0 0-2.622 2.622C22 26.56 22 28.24 22 31.6v16.8c0 3.36 0 5.04.654 6.324a6 6 0 0 0 2.622 2.622C26.56 58 28.24 58 31.6 58h16.8c3.36 0 5.04 0 6.324-.654a6 6 0 0 0 2.622-2.622C58 53.44 58 51.76 58 48.4V40"
    />
  </svg>
);
export default SvgCheck;
